export default __webpack_public_path__ + "icon_menu.63d69ec877524bb7b42a97931b222268.svg";